/**
 * @generated SignedSource<<9f823bb3a4d267bc4f04c9d8eee92e4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReportSearchType = "month" | "year";
export type ReportYearlyScreenQuery$variables = {
  date: string;
  searchType: ReportSearchType;
};
export type ReportYearlyScreenQuery$data = {
  readonly sales: {
    readonly " $fragmentSpreads": FragmentRefs<"ReportSales">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReportPostList">;
};
export type ReportYearlyScreenQuery = {
  response: ReportYearlyScreenQuery$data;
  variables: ReportYearlyScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "searchType",
    "variableName": "searchType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportYearlyScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sales",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportSales"
          }
        ],
        "storageKey": null
      },
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "ReportPostList"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportYearlyScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sales",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isSales"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalMargin",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalPayment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalSales",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalTaxDeduction",
                "storageKey": null
              }
            ],
            "type": "SalesSummary",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "SalesError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Post",
        "kind": "LinkedField",
        "name": "completedPosts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Candidate",
            "kind": "LinkedField",
            "name": "candidate",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customPrice",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Post",
                "kind": "LinkedField",
                "name": "post",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "finishedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Campaign",
                "kind": "LinkedField",
                "name": "campaign",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "parentMediaType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Banner",
                    "kind": "LinkedField",
                    "name": "banners",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "file",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "be0de803022afb9ff7964a86f268b2eb",
    "id": null,
    "metadata": {},
    "name": "ReportYearlyScreenQuery",
    "operationKind": "query",
    "text": "query ReportYearlyScreenQuery(\n  $date: String!\n  $searchType: ReportSearchType!\n) {\n  sales(date: $date, searchType: $searchType) {\n    __typename\n    ...ReportSales\n    ... on SalesSummary {\n      id\n    }\n  }\n  ...ReportPostList_4lyisT\n}\n\nfragment CampaignSmallCandidate on Candidate {\n  id\n  price\n  customPrice\n  status\n  post {\n    id\n    status\n    finishedAt\n  }\n  campaign {\n    id\n    title\n    parentMediaType\n    banners {\n      file\n      id\n    }\n  }\n}\n\nfragment ReportPostList_4lyisT on Query {\n  completedPosts(date: $date, searchType: $searchType) {\n    id\n    candidate {\n      ...CampaignSmallCandidate\n      id\n    }\n  }\n}\n\nfragment ReportSales on Sales {\n  __isSales: __typename\n  ...ReportSummaryData\n}\n\nfragment ReportSummaryData on Sales {\n  __isSales: __typename\n  __typename\n  ... on SalesSummary {\n    date\n    id\n    totalMargin\n    totalPayment\n    totalSales\n    totalTaxDeduction\n  }\n  ... on SalesError {\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed5b04ae4042df3320a91650589907c9";

export default node;
